// udostępniamy globalnie
window.nowidows = function(selector = '.js-nowidows') {

  function cleanNbsp(text) {
    return text.replace(/&nbsp;/g, ' ');
  }

  function fixWidowsInText(text) {
    // pojedyncze litery: i, a, w, z, o, u
    text = text.replace(/\b([aiouwzAIUOWZ])\s+/g, '$1\u00A0');
    // liczba + słowo
    text = text.replace(/(\d+)\s+([^\s\d]+)/g, '$1\u00A0$2');
    return text;
  }

  function walkAndFix(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      node.textContent = fixWidowsInText(cleanNbsp(node.textContent));
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      if (['SCRIPT', 'STYLE', 'NOSCRIPT', 'CODE', 'PRE'].includes(node.tagName)) return;
      for (const child of node.childNodes) {
        walkAndFix(child);
      }
    }
  }

  document.querySelectorAll(selector).forEach(el => walkAndFix(el));
};

document.addEventListener('DOMContentLoaded', () => {
  window.nowidows();
});